import { tenantLocationAtom } from "atoms/tenantLocationAtom.ts";
import { SectionHeader } from "components/UI/SectionHeader";
import {usePaldockTranslation} from "hooks/usePaldockTranslation";
import { useRecoilValue } from "recoil";

export const LocationSectionHeader = () => {
    const { t } = usePaldockTranslation("pages");
    const tenantLocationState = useRecoilValue(tenantLocationAtom);
    return <SectionHeader title={t(`${tenantLocationState.locationTag}.title`)} />;
};
